import { fetchTokenPayload as coreFetchTokenPayload } from '@restaurant/core'
import type { ShowcasePayload } from './showcase'
export { adaptPreviewAsset, type PreviewAssetRow } from '@restaurant/core'

export async function fetchTokenPayload(token: string): Promise<ShowcasePayload | null> {
  return coreFetchTokenPayload(
    import.meta.env.VITE_SUPABASE_URL ?? '',
    import.meta.env.VITE_SUPABASE_ANON_KEY ?? '',
    token,
  )
}
